// extracted by mini-css-extract-plugin
export default {"Paragraph":"DHcTGNkF"};